import { EnvironmentProviders, inject, provideAppInitializer, Provider } from '@angular/core';
import { provideStates } from '@ngxs/store';

import { GoalCountersState } from './goal-counters.state';
import { GoalCountersStateService } from './goal-counters-state.service';

export function provideGoalCounters(): (Provider | EnvironmentProviders)[] {
  return [
    provideStates([GoalCountersState]),
    provideAppInitializer(() => {
      const service = inject(GoalCountersStateService);
      service.init();
    }),
  ];
}
